import React from 'react';

import getColor from '../../../utils/getColor';
import styles from './styles/box-status.module.css';

export default function BoxStatus({ width, iconSize, status, icon, text }) {
    const color = getColor(status);

    const size = iconSize || '16px';

    return (
        <div className={styles.wrapper} style={{ width, borderColor: color, color }}>
            {icon && 
                <div style={{ width: size, height: size, color }}>
                    {icon}
                </div>
            }
            {text}
        </div>
    );
}
